import script from "./AdoptDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdoptDetail.vue?vue&type=script&lang=ts&setup=true"

import "./AdoptDetail.vue?vue&type=style&index=0&id=0ac30e01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ac30e01"]])

export default __exports__